export const LISTAR_PLANO_DE_ACAO = "LISTAR_PLANO_DE_ACAO";
export const EDITAR_ACAO = "EDITAR_ACAO";
export const CRIAR_ACAO = "CRIAR_ACAO";
export const EXCLUIR_ACAO = "EXCLUIR_ACAO";
export const LISTAR_ACAO = "LISTAR_ACAO";
export const RECUSAR_ACAO = "RECUSAR_ACAO";
